<template>
  <i class="item-show fa fa-shopping-cart" @click="onClick()"></i>
</template>

<script>
  import {mapActions} from 'vuex'
  export default {
    name: 'itemsPicker',

    props: {
      rowData: {
        type: Object,
        required: true
      },

      rowIndex: {
        type: Number
      }
    },
    methods: {
      ...mapActions([
        'setCurrentItems'
      ]),
      onClick () {
        this.setCurrentItems(this.rowData)
        console.log(this.rowData)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .item-show {
    &:hover {
        opacity: 0.6;
        cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tables/ItemsPicker.vue